import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ComparisonSetWithoutOwn } from 'frontend-utils/utils/constants/benchmark-insight';

export default class BeniHotel extends Model {
  [Type] = 'benchmark-insight/hotel' as const;

  @attr()
  declare availableComparisonSets: ComparisonSetWithoutOwn[];
}
